import React, { useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";
import { EditOutlined } from "@material-ui/icons";
import { AttachFileOutlined } from "@material-ui/icons";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Loading from "../core/Loading";
import AlertPermanent from "../core/AlertPermanent";
import TableContext from "../../context/table/tableContext";
import BillContext from '../../context/bill/BillContext'

const styles = (theme) => ({
  root: {
    display: "flex",
    marginTop: theme.spacing(3),
    //height: "100%",
    overflow: 'auto',
   
  },
  table: {
    minWidth: 340,
  },
  tableCell: {
    padding: "16px",
    color: "#12b1ee",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 70,
  },
  documentNumber: {
    cursor: "pointer",
  },
  actionIcon:{
    cursor:'pointer',
    paddingLeft:'15px',
    fontSize: '2.5rem',
    color:'#101070'
  },
  referenceSelection:{
  }
});

const BillTable = (props) => {
  const tableContext = useContext(TableContext);
  const [currentBills,setData] = React.useState()
  const [billToRefer,setBillToRefer] = React.useState()
  const [loadingReference,setLoadingReference] = React.useState(false)
  const [referenceSelection,setReferenceSelection] = React.useState()
  const [errorMessage,setErrorMessage]=React.useState()
  const billContext =useContext(BillContext)
  const{
    bills,
    totalPages,
    setBillAllParams,
    currentPage,
    maxPerPage,
    getBill,
    customerId,
    shopId,
    billData,
    error
  } = billContext

  const {
    classes,
    columns,
  } = props;

  function formatCurrency(value) {
    const formatter = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatter.format(value);
  }

  const handlePagination = (e, page) => {
    e.preventDefault();
    const params={}
    params.currentPage=page
    setBillAllParams(params)
  };

  const handleChangeRowsPerPage = (e) => {
   const params={}
   params.maxPerPage=parseInt(e.target.value)
   setBillAllParams(params)
  };

  function showPdf(event){
  //  //console.log(event.currentTarget.attributes.pdfbillurl)
    if(event.currentTarget.attributes.pdfbillurl){
        window.open(event.currentTarget.attributes.pdfbillurl.value,'_blank')
    }
  }
  function referBill(event){
    setBillToRefer(currentBills[event.currentTarget.attributes.data.value])
    const rs = document.getElementById('ReferenceSelection')

//    //console.log('rs',rs)
    if(rs){
        rs.style.position='fixed'
        rs.style.left=event.screenX
        rs.style.top=event.screenY
    }
  }

  function documentTypeToName(type){
    switch(type){
        case 33:
        case 34:
        case 46:
            return 'Factura'
        case 56: return 'Nota de Débito'
        case 61: return 'Nota de Crédito'
        case 52: return 'Guía de depacho'
    }
  }
  React.useEffect(()=>{
      if(getBill&&billToRefer&&customerId&&shopId){
        setLoadingReference(true)
        getBill(customerId,shopId,billToRefer.id)
        //
      }
  },[billToRefer])

  React.useEffect(()=>{
      if(bills){
        setData(bills)
      }
  },[bills])

  React.useEffect(()=>{
      ////console.table(billData,billToRefer)
      setLoadingReference(false)
      setBillToRefer()
      if(billData && billData.data&&billData.data.availableDocumentsToReference==null){
     //   if(location.pathname === '/app/bills-list'){
           alert('Este documento no se puede referenciar')
           return
   //    }
      }

      if(billData && billData.data && billData.data.availableDocumentsToReference && billData.data.availableDocumentsToReference.length){
        const nrs = []
        billData.data.availableDocumentsToReference.forEach( x=> {
            if(x.availableReasonToRefer === null){
               nrs.push({
                      value:0,
                      label: 'Duplicar '+documentTypeToName(x.typesToRefer),
                     // label: 'Duplicar',
                      typesToRefer: x.typesToRefer
                  })
            }else{
                nrs.push({
                      value:x.typesToRefer,
                      label: 'Generar '+documentTypeToName(x.typesToRefer),
                     // label: r.label,
                      typesToRefer: x.typesToRefer
                  })
            }

        })
        if(billToRefer){
            const dt = {}
            dt.documentUniqueNumber = billToRefer.documentUniqueNumber
            dt.documentType = billToRefer.documentTypeCode
            dt.documentDate = billToRefer.timeStamp.substring(0,10)
            dt.availableDocumentsToReference=billData.data.availableDocumentsToReference
            dt.Details = billData.data.details
            dt.ReceiverId = billData.data.receiverId
            dt.documentId = billData.data.id
            props.showReferencesOptions(nrs,dt)
        }
}

  },[billData])

  React.useEffect(()=>{
    if(error) {
        setErrorMessage(error)
        setData([])

    }

  },[error])
  if (!currentBills) {
    return <Loading />;
  }

  if (errorMessage) {
    return <AlertPermanent category="error" message={errorMessage} />;
  }

  if (currentBills.length === 0 && !error) {
    return (
      <AlertPermanent
        category="info"
        message="No se han encontrado registros..."
      />
    );
  }
  return (
    <>

      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  align={ "center"}
                  className={classes.tableCell}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentBills.map((n,k) => {
              return (
                <TableRow key={n.id}>
                  <TableCell 
                    component="th"
                    scope="row"
                    className={classes.TableCell}
                    align="center">
                    {n.timeStamp.substring(0,10)}
                  </TableCell>
                  <TableCell align="center">
                    {n.timeStamp.substring(11,30)}
                  </TableCell>
                  <TableCell padding="none" align="center">{n.documentType}</TableCell>
                  <TableCell  padding="none" align="center">{n.documentUniqueNumber}</TableCell>
                  <TableCell padding="none" align="center"
                    >{formatCurrency(n.totalAmount)}</TableCell>
                  <TableCell padding="none" align="center">
                    {n.status}
                  </TableCell>
                  <TableCell padding="none" align="center">
                   {n.pdfBillUrl && <AttachFileOutlined  className={classes.actionIcon} pdfbillurl={n.pdfBillUrl} onClick={showPdf}/> }
                   <EditOutlined  className={classes.actionIcon} data={k} onClick={referBill}/>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          //backgroundColor: "#EAEAEA"
          
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Registros</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={maxPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          page={currentPage}
          count={totalPages}
          onChange={handlePagination}
          showFirstButton showLastButton
          style={{ marginTop: "10px", justifyContent: "center" }}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(BillTable);
